// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"56":"56bf960c","370":"8aff65ad","824":"a45882db"}[chunkId] + ".js";
};